module.exports = __webpack_public_path__ + "img/6.87e6155b.jpg";